/**
 * @param {number} amount
 * @param {number} terms
 * @returns {{total: *, monthly: *}}
 */
function calculateDebtRegistryChargeCard ({ amount, terms } = {}) {
  return {
    total: amount || 0,
    monthly: amount / terms || 0
  }
}

module.exports = { calculateDebtRegistryChargeCard }
